<template>
  <div class="list-container column">
    <div class="title">
      {{ $t('map_item_list.title') }} {{ title }}
    </div>
    <div class="panel-list-header">
      <div class="panel-filler" v-if="$isAllowedTo('floor_areas_edit')" />
      <div class="panel-header-item pos">{{ $t('map_item_list.position_number') }}</div>
      <div class="panel-header-item">{{ $t('map_item_list.name') }}</div>
      <div class="panel-header-item">{{ $t('map_item_list.year') }}</div>
      <div class="panel-filler" v-if="$isAllowedTo('floor_areas_edit')" />
      <div class="panel-filler" v-if="$isAllowedTo('floor_areas_edit')" />
    </div>
    <div
      class="panel-list"
      v-for="item in items"
      :key="item.id"
      @click.stop="onEditItem(item)"
    >
      <div class="panel-list-buttons" v-if="$isAllowedTo('floor_areas_edit')">
        <div class="positioner-container">
          <div class="positioner" @click.stop="position(item, -1)">
            <i class="fas fa-sm fa-minus"></i>
          </div>
          <div class="positioner" @click.stop="position(item, 1)">
            <i class="fas fa-sm fa-plus"></i>
          </div>
        </div>
      </div>
      <p class="panel-list-item pos">{{ formatPos(item.positionNumber) }}</p>

      <p class="panel-list-item" :title="preferCategoryLabel(item.fireProtection)">
        {{ preferCategoryLabel(item.fireProtection) }}
      </p>

      <p class="panel-list-item">{{ getYear(item) }}</p>
      <div
        class="list-button"
        v-if="$isAllowedTo('floor_areas_edit')"
        @click.stop="onEditItem(item)"
      >
        <i class="fas fa-edit"></i>
      </div>
      <div
        class="list-button"
        v-if="$isAllowedTo('floor_areas_edit')"
        @click.stop="onDeleteItem(item)"
      >
        <i class="fas fa-trash-alt"></i>
      </div>
    </div>
    <div class="panel-list no-hover" v-if="items.length == 0">
      <p class="panel-list-item">{{ $t('map_item_list.no_results') }}</p>
    </div>
    <Pagination
      v-if="items.length > 0"
      :pagination="pagination"
      @paginate="paginate"
      @updatePageSize="updatePageSize"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination';
import iconMixin from '@/mixins/iconMixin.js';
import { mapGetters, mapActions } from 'vuex';

export default {
  mixins: [iconMixin],
  components: { Pagination },
  props: {
    map: Object,
    building: Object,
    items: Array,
    floor: Object,
  },
  computed: {
    ...mapGetters('appStore', ['isMobile']),
    ...mapGetters('mapItemStore', ['pagination']),

    title() {
      return this.building?.customer
        ? `${this.floor?.name} | ${this.building?.name} | ${this.building.customer?.name}`
        : '';
    },
    mapHasNoFile() {
      if (this.map) {
        if (this.map.file) return false;
      }
      return true;
    }
  },
  methods: {
    ...mapActions('mapItemStore', ['setCurrentPage', 'setPageSize']),
    getYear(item) {
      const y = (item?.year || '').toString().slice(0, 4);
      return !y || y === '0001' ? '-' : y;
    },
    onDeleteMap() {
      this.$emit('delete-map', this.map);
    },
    onDeleteItem(item) {
      this.$emit('delete-item', item);
    },
    onEditMap() {
      this.$emit('edit-map', this.map);
    },
    onEditItem(item) {
      this.$emit('edit-item', item);
    },
    paginate(page) {
      this.setCurrentPage(page);
      this.$emit('paginate');
    },
    updatePageSize(size) {
      this.setPageSize(size);
      this.setCurrentPage(1);
      this.$emit('paginate');
    },
    normalizeTo1Decimal(value) {
      const EPS = 1e-9;

      const n = Number(value);
      if (!Number.isFinite(n)) return 0;

      const rounded = Math.round((n + EPS) * 10) / 10;

      const intRounded = Math.round(rounded);
      if (Math.abs(rounded - intRounded) < EPS) return intRounded;

      return rounded;
    },
    normalize(value) {
      return this.normalizeTo1Decimal(value);
    },
    position(item, delta) {
      const current = this.normalize(item.positionNumber);
      item.positionNumber = this.normalize(current + delta);
      this.$emit('update', item);
    },
    formatPos(value) {
      return this.normalize(value);
    }
  },
  watch: {
    items: {
      immediate: true,
      deep: true,
      handler(list) {
        for (const item of list || []) {
          const n = Number(item.positionNumber);
          if (Number.isFinite(n)) {
            const r = Math.round(n);
            if (Math.abs(n - r) < 1e-9) item.positionNumber = r;
          }
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/colors.scss";

.panel-list-item.pos,
.panel-header-item.pos {
  max-width: 80px;
}
.panel-list-buttons {
  min-width: 32px;
  position: relative;
  .positioner-container {
    position: absolute;
    top: -8px;
    .positioner {
      position: relative;
      box-sizing: border-box;
      width: 20px;
      height: 20px;
      background: $info;
      text-align: center;
      border-radius: 2px;
      border: 1px solid $info-active;
      margin-bottom: 2px;
      &:hover {
        background: $white;
        i { color: $info; }
      }
      cursor: pointer;
      i {
        position: absolute;
        top: 2px;
        right: 15%;
        color: $white;
      }
    }
  }
}
</style>
